import React, {Component} from 'react';
import {AgGridReact} from 'ag-grid-react';

import * as firebase from 'firebase';

import 'ag-grid/dist/ag-grid.js';
import 'ag-grid/dist/ag-grid.min.js';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-fresh.css';

//import './user.scss';

class StudentStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            students: [],
            value: "",
            user: this.props.user,
            MarketVWAP: '',
            gridOptions: {
                defaultColDef: {
                    editable: false
                },
                api: {},
                columnApi: {},
                columnDefs: [
                    {
                        headerName: "ID",
                        field: "id",
                        width: 75,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "User",
                        field: "user",
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "ABC",
                        field: "abc",
                        width: 100,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Cash",
                        field: "cash",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "P/L",
                        field: "pl",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "AverageBuyPrice",
                        field: "avgbuy",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "AverageSellPrice",
                        field: "avgsell",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "BuyVwapDiff",
                        field: "buyvwapDiff",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "SellVwapDiff",
                        field: "sellvwapDiff",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    }
                ],
                pagination: true,
                floatingFilter: true,
                rowData: '',
                enableSorting: true,
                onGridReady: this.onGridReady.bind(this),
                enableFilter: true
            }
        }
    }

    componentDidMount() {
        this.waitingRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("StartSim");
        this.pendingRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        this.userRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("Users");
        this.vwapRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("Assets").child("INTC").child("VWAP");

        var username, shares, cash, BuyVWAP, SellVWAP, pl, MarketVWAP;
        var that = this;
        this.waitingRef.on('value', ss => {
          var data = ss.val();
          if (!data){
            console.log("not ready yet");
            return null;
          }
          if (!data.hasOwnProperty("start")){
            //In this world we only have Pending Users
            that.pendingRef.on('value', ss => {
              var data = ss.val();
              if (!data){
                console.log("No pending participants");
                return null;
              }
              var stdnts = [];
              for (var key in data) {
                let studentData = data[key];
                stdnts.push({
                    //need to read user object i think
                    "User": studentData.displayName,
                    "Shares": "-",
                    "Cash": "-",
                    "PL": "-",
                    "AverageBuyPrice": "-",
                    "AverageSellPrice": "-",
                    "MarketVWAP": "-"
                });

              }
              that.setState({
                  students: stdnts
              });
              that.createRows();  
            });
          } else {
            //In this world the session is running or already ran so users exist.
            that.vwapRef.on('value', snap => {
                if (snap.val()) {
                    that.setState({
                        MarketVWAP: snap.val()
                    });
                } else {
                    that.setState({
                        MarketVWAP: ''
                    });
                }
            });

            that.userRef.on('value', snap => {
                var rawData = snap.val();
                var stdnts = [];
                for (var key in rawData) {
                    if (key !== '0') {
                        username = rawData[key].DisplayName;
                        shares = rawData[key].Assets.INTC.Stats.Shares;
                        cash = rawData[key].Assets.Cash;
                        pl = rawData[key].Assets.INTC.Stats.PL;
                        //console.log(pl);
                        BuyVWAP = rawData[key].Assets.INTC.Stats.BuyVWAP;
                        SellVWAP = rawData[key].Assets.INTC.Stats.SellVWAP;
                        MarketVWAP = this.state.MarketVWAP;

                        stdnts.push({
                            //need to read user object i think
                            "User": username,
                            "Shares": shares,
                            "Cash": cash,
                            "PL": pl,
                            "AverageBuyPrice": BuyVWAP,
                            "AverageSellPrice": SellVWAP,
                            "MarketVWAP": MarketVWAP
                        });
                    }
                }
                that.setState({
                    students: stdnts
                });
                that.createRows();
            });
          }
        });


    }

    componentWillUnmount() {
        this.vwapRef.off();
        this.userRef.off();
    }

    filterQuick(event) {
        console.log(this.state.gridOptions.rowData);
        this.state.gridOptions.api.setQuickFilter(event.target.value);

    }

    createRows() {
        let rows = [];
        for (let i = 0; i < this.state.students.length; i++) {
            rows.push({
                id: i + 1,
                user: this.state.students[i].User,
                abc: this.state.students[i].Shares,
                cash: this.state.students[i].Cash,
                pl: this.state.students[i].PL,
                avgbuy: this.state.students[i].AverageBuyPrice,
                avgsell: this.state.students[i].AverageSellPrice,
                buyvwapDiff: (this.state.MarketVWAP - this.state.students[i].AverageBuyPrice).toFixed(2),
                sellvwapDiff: (this.state.students[i].AverageSellPrice - this.state.MarketVWAP).toFixed(2)
            });
        }
        this.state.gridOptions.rowData = rows;
        this.setState(this.state);
    }

    onGridReady(params) {
        this.state.gridOptions.api = params.api;
        this.state.gridOptions.columnApi = params.columnApi;
        this.state.gridOptions.api.selectAll();
        this.setState(this.state)
    }

    render() {
        return (
            <div>
                <button onClick={() => this.state.gridOptions.api.exportDataAsCsv()}>export</button>
                <div className="leader-board ag-theme-material">
                    <AgGridReact
                        columnDefs={this.state.gridOptions.columnDefs}
                        rowData={this.state.gridOptions.rowData}
                        gridOptions={this.state.gridOptions}
                    />
                </div>
            </div>
        );
    }
}

export default StudentStats



// WEBPACK FOOTER //
// ./src/components/Dashboard/StudentStats.js